export default {
  userMenu: [
    {
      name: 'administration',
      caption: 'УПРАВЛЕНИЕ',
      parent_id: null,
      id: 20,
      link: '/administration',
      icon: 'fas fa-users',
      children: [
        {
          name: 'organisations-users',
          caption: 'Организации и пользователи',
          parent_id: 20,
          id: 7,
          link: '/administration/organisations-users',
          children: []
        },
        {
          name: 'dealers',
          caption: 'Дилеры и прайсы',
          parent_id: 20,
          id: 8,
          link: '/administration/dealers-prices',
          children: []
        },
        {
          name: 'categories',
          caption: 'Новости',
          parent_id: 20,
          id: 32,
          link: '/administration/categories',
          children: []
        }
      ]
    },
    {
      name: 'reports',
      caption: 'ОТЧЕТЫ',
      parent_id: null,
      id: 6,
      link: '/reports',
      icon: 'fas fa-file-invoice-dollar',
      children: [
        {
          name: 'web_client_reports_otvt_tk',
          caption: 'Пакеты ТК (старый)',
          parent_id: 6,
          id: 14,
          link: '/reports/web_client_reports_otvt_tk'
        },
        {
          name: 'web_client_reports_pi_classic',
          caption: 'ПИ (старый)',
          parent_id: 6,
          id: 15,
          link: '/reports/web_client_reports_pi_classic'
        },
        {
          name: 'web_client_reports_pi_from_uin',
          caption: 'ПИ (с УИН)',
          parent_id: 6,
          id: 16,
          link: '/reports/web_client_reports_pi_from_uin'
        },
        {
          name: 'web_client_reports_transite_vypusk',
          caption: 'Транзит',
          parent_id: 6,
          id: 17,
          link: '/reports/web_client_reports_transite_vypusk'
        },
        {
          name: 'package-statistic',
          caption: 'Статистика по пакетам',
          parent_id: 6,
          id: 19,
          link: '/reports/package-statistic',
          children: []
        },
        {
          name: 'sales-statistic',
          caption: 'Статистика продаж',
          parent_id: 6,
          id: 21,
          link: '/reports/sales-statistic',
          children: []
        },
        {
          name: 'report_fixed_packages',
          caption: 'Тариф минимальный',
          parent_id: 6,
          id: 30,
          link: '/reports/report_fixed_packages',
          children: []
        },
        {
          name: 'report_active_users',
          caption: 'Отчет по учетным записям',
          parent_id: 6,
          id: 31,
          link: '/reports/active_users',
          children: []
        }
      ]
    },
    {
      name: 'product_client',
      caption: 'ПРОГРАММА',
      parent_id: null,
      id: 26,
      link: '/product',
      icon: 'fas fa-laptop-code',
      children: [
        {
          name: 'client',
          caption: 'Скачать дистрибутив',
          parent_id: 26,
          id: 27,
          link: '/product/client',
          children: []
        }
      ]
    }
  ]
}
